import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation, validations } from "../../common/validation.common";
import { RadiusProfileCommonSchema } from "../radius_profile/radius_profile.request";

export namespace RadiusAccountValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            label: v.optional(baseVals.string()),
            username: baseVals.string(),
            password: baseVals.string(),
            radiusProfile: v.object({
                isActive: v.boolean(),
                ...RadiusProfileCommonSchema.create.entries,
            }),
        }),
    );

    export const Update = defineValidation(
        v.object({
            label: v.exactOptional(baseVals.string()),
            username: v.exactOptional(baseVals.string()),
            password: v.exactOptional(baseVals.string()),
            radiusProfile: v.exactOptional(
                v.object({
                    isActive: v.boolean(),
                    ...RadiusProfileCommonSchema.create.entries,
                }),
            ),
        }),
    );

    export const Remove = defineValidation(
        v.object({
            macAddress: validations.deletable,
        }),
    );
}
